import * as React from 'react';
import { THomePage } from './HomePage.types';
import { PromoBanner } from './components/PromoBanner/PromoBanner';
import { InfoBlocks } from './components/InfoBlocks/InfoBlocks';
import './HomePage.styled.scss';

export const HomePage: THomePage = () => {
  return (
    <div className="home-page">
      <PromoBanner />
      <div className="home-page__container">
        {/* <ProductsOfDay /> */}
        <InfoBlocks />
      </div>
    </div>
  );
};
